<div *ngIf="data?.length>0" class="level-select-dropbox">
  <div ngbDropdown class="d-inline-block">
      <button type="button" class="btn btn-level-select" id="dropdownLevelSelect" ngbDropdownToggle>
          <span class="text">{{label}}</span>

          <span class="icon-wrap">
              <img src="./assets/images/ic-arrow-down-dark.svg" alt="Icon" />
          </span>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownLevelSelect">
            <button ngbDropdownItem *ngFor="let option of data" (click)="onOptionSelect(option)"
            [attr.aria-selected]="selectValue === option.value ? true : false">
              <div class="level-li-inner {{option[optionStyle]}}" >
                  <div>
                      <h5  *ngIf="textField">{{ option[textField] }}</h5>
                      <p *ngIf="descrptionField">{{ option[descrptionField] }}</p>
                  </div>
                  <span class="check-show"></span>
              </div>
          </button>
      </div>
  </div>
</div>
